import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Input from '../../../common/input';
import CurrencyInput from '../../../common/currencyInput';
import { trimFunction } from '../../../common/trimData';
import { containerApp } from '../../../../main';
import BarberPicker from '../containers/BarberPicker';

const GiftCardForm = ({ handleSubmit, submitting, pristine, valid, charge, isRentalShop, isRentalBarber }) => {
  const inputGroupClassName = cx('layout__item', {
    'u-1/3-large-and-up': isRentalShop,
    'u-1/2-large-and-up': !isRentalShop,
  });
  const containerClassName = cx('u-margin-auto', {
    'u-max-width-710': isRentalShop,
    'u-max-width-400': !isRentalShop,
  });
  return (
    <div className="c-wrapper" display-if={!containerApp.isActive()}>
      <div className={containerClassName}>
        <div className="u-pt">
          <form>
            <fieldset disabled={submitting}>
              <div className="layout layout--small">
                <div className={inputGroupClassName}>
                  <span className="c-label-new u-block">Code (optional)</span>
                  <Input
                    className="c-input c-input--white u-height-40"
                    id="code"
                    name="code"
                    normalize={value => (value || '').toUpperCase()}
                    placeholder="Enter gift card number"
                  />
                </div>
                <div className={inputGroupClassName} display-if={isRentalShop && !isRentalBarber}>
                  <span className="c-label-new u-block">Barber</span>
                  <div className="c-input-group">
                    <BarberPicker />
                  </div>
                </div>
                <div className={inputGroupClassName}>
                  <span className="c-label-new u-block">Amount</span>
                  <div className="c-input-group">
                    <div className="u-flex-1">
                      <CurrencyInput
                        className="c-input c-input--white u-height-40 c-input-group__first u-border-right-none u-1/1"
                        placeholder="Enter amount"
                        type="number"
                        pattern="[\d\.]*"
                        step="0.01"
                        name="amount"
                        format={val => parseInt(val, 10) || 0}
                      />
                    </div>
                    <button
                      type="submit"
                      className="c-btn c-btn--medium"
                      disabled={pristine || !valid}
                      name="chargeCB"
                      onClick={handleSubmit(trimFunction(charge))}
                    >
                      <span className="c-btn__text">Charge</span>
                    </button>
                  </div>
                </div>
              </div>
            </fieldset>
          </form>
        </div>
      </div>
    </div>
  );
};

GiftCardForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  charge: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  isRentalShop: PropTypes.bool.isRequired,
  isRentalBarber: PropTypes.bool.isRequired,
};

export default GiftCardForm;
